module.exports = __webpack_public_path__ + "static/SSTArabic-Bold-e2803eb5609f39a9f3c2b60ef55dfeeb.otf";